//Library Imports
import { useDispatch } from "react-redux";
//Local Imports
import Edit from "assets/img/icons/EditWorkflow.svg"
import Delete from "assets/img/icons/DeleteWorkflow.svg"
import CopyWorkFlow from "assets/img/icons/CopyWorkFlow.svg";
// actions Imports
import { addActionModal, copyNode, deleteActionModal, deleteConditionModal } from "../actions";

type PopoverContentProps = {
  id: string;
  isCondition?: boolean;
  controlName?: string;
  canCopy?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;
}

export default function PopoverContent(props: PopoverContentProps) {
  const { id, isCondition, controlName, canCopy, canEdit, canDelete } = props;
  const dispatch = useDispatch();

  return (
    <div>
      <ul>
        {
          canEdit && (<li onClick={() => {
            dispatch(addActionModal(true, id, controlName));
          }}>
            <img src={Edit} alt="edit node" />
          </li>)
        }
        {
          canDelete && (<li onClick={() => {
            if (isCondition) {
              dispatch(deleteConditionModal(true, id));
            } else {
              dispatch(deleteActionModal(true, id));
            }
          }}>
            <img src={Delete} alt="delete node" />
          </li>)
        }
        {
          canCopy && (<li onClick={() => dispatch(copyNode(id))}>
            <img src={CopyWorkFlow} alt="copy node" />
          </li>)
        }
      </ul>
    </div>
  )
}

PopoverContent.defaultProps = {
  isCondition: false,
  canCopy: true,
  canEdit: true,
  canDelete: true,
}
